import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    DestroyRef,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { EnhancedFormGroup } from '../../classes/enhanced-formgroup';
import { CustomerFormGroup, CustomersFormGroup } from '../../interfaces/customer';
import { FormsCustomerComponent } from '../forms-customer/forms-customer.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-forms-customer-info',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatExpansionModule, FormsCustomerComponent],
    templateUrl: './forms-customer-info.component.html',
    styleUrl: './forms-customer-info.component.scss',
})
export class FormsCustomerInfoComponent implements AfterViewInit, OnChanges {

    @Input() public formGroup: EnhancedFormGroup<CustomersFormGroup> | FormGroup | undefined;

    public constructor(
        private readonly destroyRef: DestroyRef,
        private readonly cdr: ChangeDetectorRef,
    ) {
        //
    }

    public get customers(): FormArray<CustomerFormGroup> {
        return this.formGroup?.get('customers') as FormArray<CustomerFormGroup>;
    }

    public applyAdapters(): void {
        (this.formGroup as EnhancedFormGroup<CustomersFormGroup>)?.applyAdapters();
    }

    public ngAfterViewInit(): void {
        this.subscribeToFormGroupChanges();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['formGroup']) {
            this.subscribeToFormGroupChanges();
        }
    }

    private subscribeToFormGroupChanges(): void {
        this.applyAdapters();

        this.formGroup?.valueChanges.pipe(
            takeUntilDestroyed(this.destroyRef),
            debounceTime(100),
            distinctUntilChanged(),
        ).subscribe(() => {
            this.applyAdapters();
            this.cdr.detectChanges();
        });
    }
}
